import type { TOC } from '@ember/component/template-only';

const PreferredUnitCachePendingMessage: TOC<object> = <template>
  <div class='ui pink message !bg-pink-light !text-pink visible !mt-2'>
    La mise à jour des unités d'affichage est en cours. Certaines données
    peuvent temporairement s'afficher dans des unités différentes.
  </div>
</template>;

export default PreferredUnitCachePendingMessage;
